import React from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { cn } from '@/lib/utils';

export function TooltipProvider({ children, delayDuration = 150, skipDelayDuration = 75 }) {
  return (
    <TooltipPrimitive.Provider delayDuration={delayDuration} skipDelayDuration={skipDelayDuration}>
      {children}
    </TooltipPrimitive.Provider>
  );
}

export default function Tooltip({
  label,
  children,
  className,
  position = 'top',
  align = 'center',
  sideOffset = 10,
  contentClassName,
}) {
  if (!label || !children) {
    return children;
  }

  return (
    <TooltipPrimitive.Provider delayDuration={120} skipDelayDuration={80}>
      <TooltipPrimitive.Root>
        <TooltipPrimitive.Trigger asChild>
          <span className={cn('inline-flex items-center', className)}>
            {children}
          </span>
        </TooltipPrimitive.Trigger>
        <TooltipPrimitive.Content
          side={position}
          align={align}
          sideOffset={sideOffset}
          className={cn(
            'z-[60] max-w-xs rounded-2xl border border-white/10 bg-slate-950/80 px-3 py-2 text-xs font-medium text-white shadow-finlist-md backdrop-blur',
            'data-[state=delayed-open]:animate-in data-[state=delayed-open]:fade-in data-[state=delayed-open]:zoom-in-95',
            'data-[state=closed]:animate-out data-[state=closed]:fade-out data-[state=closed]:zoom-out-95',
            'data-[side=top]:slide-in-from-bottom data-[side=bottom]:slide-in-from-top data-[side=left]:slide-in-from-right data-[side=right]:slide-in-from-left',
            'pointer-events-none select-none leading-relaxed text-slate-50/90',
            contentClassName
          )}
        >
          <span>{label}</span>
          <TooltipPrimitive.Arrow className="fill-slate-950/80" />
        </TooltipPrimitive.Content>
      </TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  );
}
